import axios from 'axios'

import { FRAGSOL_MINT } from '.'

const FRAGMETRIC_API_URL = 'https://api.fragmetric.xyz'

//? Type is only partially described! To get apy only
type FragmetricAddressesResponseData = Record<
  string,
  {
    address: string
    data: {
      apy: number
      oneTokenAsSOL: number
    }
    symbol: string
  }
>

export const fetchFragSolConversionRate = async () => {
  const { data } = await axios.get<FragmetricAddressesResponseData>(
    `${FRAGMETRIC_API_URL}/v1/public/feeds?addresses=${FRAGSOL_MINT.toBase58()}`,
  )

  const oneTokenAsSOL = data[FRAGSOL_MINT.toBase58()]?.data?.oneTokenAsSOL

  const conversionRate = (1e9 / oneTokenAsSOL) * 0.995

  return conversionRate
}
